var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import React from "react";
const EditIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.8528 3.541L13.7518 4.642L11.3568 2.246L12.4578 1.145C12.5558 1.048 12.6838 0.999 12.8108 0.999C12.9388 0.999 13.0668 1.048 13.1648 1.145L14.8528 2.833C15.0478 3.028 15.0478 3.346 14.8528 3.541ZM4.1898 14.204C4.1188 14.274 4.0278 14.322 3.9298 14.342L1.1278 14.871L1.6578 12.068C1.6758 11.97 1.7228 11.88 1.7948 11.809L10.6498 2.953L13.0448 5.349L4.1898 14.204ZM15.5598 2.126L13.8718 0.438C13.2868 -0.146 12.3358 -0.146 11.7508 0.438L1.0878 11.101C0.873805 11.315 0.729805 11.586 0.674805 11.884L0.00880467 15.405C-0.0221953 15.567 0.0298047 15.734 0.146805 15.852C0.241805 15.946 0.368804 15.998 0.499804 15.998C0.530804 15.998 0.561805 15.995 0.592805 15.989L4.1168 15.324C4.4148 15.267 4.6858 15.123 4.8968 14.91L15.5598 4.248C16.1448 3.663 16.1448 2.711 15.5598 2.126Z",
      fill: "currentColor"
    }
  )
);
var EditIcon_default = EditIcon;
export {
  EditIcon_default as default
};
//# sourceMappingURL=EditIcon.js.map
